import { render, staticRenderFns } from "./InstantPayout.vue?vue&type=template&id=2136d6b3"
import script from "./InstantPayout.vue?vue&type=script&lang=js"
export * from "./InstantPayout.vue?vue&type=script&lang=js"
import style0 from "./InstantPayout.vue?vue&type=style&index=0&id=2136d6b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports